export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    showLocal: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit('update:show', newValue);
      },
    },

    dialogWidth() {
      let width;
      switch (this.$mq) {
        case 'mobile':
          width = '95%';
          break;
        case 'tablet':
          width = '80%';
          break;
        case 'laptop':
          width = '60%';
          break;
        case 'desktop':
          width = '750px';
          break;
        default:
          width = '60%';
      }
      return width;
    },

    passwordWidth() {
      let width;
      switch (this.$mq) {
        case 'mobile':
          width = '90%';
          break;
        case 'tablet':
          width = '65%';
          break;
        case 'laptop':
          width = '680px';
          break;
        default:
          width = '680px';
      }
      return width;
    },

    pulseSurveyWidth() {
      let width;
      switch (this.$mq) {
        case 'mobile':
          width = '90%';
          break;
        case 'tablet':
          width = '65%';
          break;
        case 'laptop':
          width = '680px';
          break;
        default:
          width = '680px';
      }
      return width;
    },

    dialogPadding() {
      let padding;
      if (['mobile', 'tablet'].includes(this.$mq)) {
        padding = '20px';
      } else {
        padding = '40px';
      }
      return padding;
    },

    pulseSurveyPadding() {
      let padding;
      if (['mobile', 'tablet'].includes(this.$mq)) {
        padding = '40px 20px';
      } else {
        padding = '40px';
      }
      return padding;
    },
  },
};
